import React from 'react'

export default function Section5() {
  return (
    <div>Section5</div>
  )
}
